import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {User} from "../../../../../classes/user";

@Component({
    selector: 'kan-user-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanUserList {
    @Input() public users: User[];
    @Input() public searchText: string;
    @Input() public loading: boolean = false;
    @Output() public refresh: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/user/list/component.ts